import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import axios from "axios";
import Select from "react-select";

const customStyles = {
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const customRequireStyles = {
  control: (base) => ({ ...base, borderColor: "red" }),
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const AddState = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [isError, setError] = useState(false);
  const [countryDrp, setCountryDrpData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [formdata, setFormData] = useState({
    id: null,
    name: "",
    country_id: "",
  });

  const getCountryDrpData = () => {
    axios.post(API_URL.COUNTRY_LIST, {}).then((res) => {
      setCountryDrpData(res.data.data);
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.name,
          value: caw.id,
        };
      });
      setCountryDrpData(cd);
    });
  };

  const onSave = () => {
    if (formdata.name && formdata.country_id) {
      setError(false);
      setLoading(true);
      const pUrl = id ? API_URL.STATE_UPDATE : API_URL.STATE_SAVE;
      axios
        .post(pUrl, formdata)
        .then((res) => {
          setLoading(false);
          if (res.data.status === 1) {
            let message = id
              ? "State Updated Successfully."
              : "State Created Successfully.";
            toast.success(message, { autoClose: 3000, position: "top-right" });
            setLoading(false);
            navigate("/admin/state");
          }
        })
        .finally(() => {
          setLoading(false);
          setError(true);
        });
    } else {
      setLoading(false);
      setError(true);
    }
  };

  const onEdit = () => {
    axios.post(API_URL.STATE_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormData({
          id: res.data.data.id,
          name: res.data.data.name ? res.data.data.name : "",
          country_id: res.data.data.country_id ? res.data.data.country_id : "",
        });
      }
    });
  };

  const isRequiredField = (key) => {
    return isError && !formdata[key];
  };

  useEffect(() => {
    getCountryDrpData();
  }, []);

  useEffect(() => {
    id && onEdit();
  }, [id]);

  return (
    <>
      <div className="page-header">
        <div className="content-page-header">
          <h5>{id ? "Update" : "Add"} State</h5>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <form>
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group">
                  <label>
                    Name<span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formdata.name}
                    className={
                      isRequiredField("name")
                        ? "form-control required"
                        : "form-control"
                    }
                    id="name"
                    onChange={(event) => {
                      setFormData({ ...formdata, name: event.target.value });
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group">
                  <label htmlFor="Country">
                    Country<span className="required-star">*</span>
                  </label>
                  <Select
                    options={countryDrp}
                    isClearable={true}
                    placeholder=""
                    value={countryDrp.find(
                      (r) => r.value == formdata.country_id
                    )}
                    styles={
                      isRequiredField("country_id")
                        ? customRequireStyles
                        : customStyles
                    }
                    onChange={(e) =>
                      setFormData({
                        ...formdata,
                        country_id: e?.value ? e.value : null,
                      })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
              <div className="text-end">
                <Link
                  to={"/admin/state"}
                  className={
                    loading
                      ? "btn btn-danger btn-sm me-2 disabled-link"
                      : "btn btn-danger btn-sm me-2"
                  }
                  onClick={(e) => loading && e.preventDefault()}
                >
                  Cancel
                </Link>
                <button
                  type="button"
                  onClick={onSave}
                  disabled={loading}
                  className="btn btn-primary btn-sm"
                >
                  <div className="d-flex justify-content-center align-items-center gap-2">
                    {loading && (
                      <Watch color={"white"} height={15} width={15} />
                    )}
                    Submit
                  </div>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddState;
